import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { numberFormatter } from "@common/helpers/number";
import { useUnsplitAllTransactions } from "@api/transaction.api";
import { useMemo } from "react";
import { pluralize } from "@common/helpers/string";
import { useBulkActions } from "../useBulkActions";

export const UnsplitAllConfirmationModal: React.FC<{
    show: boolean;
    onHide: () => void;
}> = ({ show, onHide }) => {
    const bulkActions = useBulkActions();
    const selectedTransactionsWithSplit = Object.values(
        bulkActions.selected,
    ).filter((value) => value.splitParentId);

    const uniqueTransactionIds = useMemo(() => {
        const transactionIds = selectedTransactionsWithSplit
            .map((value) => value.splitParentId)
            .filter((value) => value !== null && value !== undefined);

        return [...new Set(transactionIds)];
    }, [selectedTransactionsWithSplit]);

    const mutation = useUnsplitAllTransactions(uniqueTransactionIds, onHide);

    return (
        <ConfirmationModal
            show={show}
            onHide={onHide}
            onReject={onHide}
            onConfirmMutation={mutation}
            title={`Unsplit ${numberFormatter.format(
                selectedTransactionsWithSplit.length,
            )} ${pluralize("transaction", selectedTransactionsWithSplit.length)}`}
            question={`Are you sure you want to unsplit selected ${pluralize("transaction", selectedTransactionsWithSplit.length)}?`}
            yes="Unsplit"
            yesBtnVariant="primary"
        />
    );
};
